module.exports = __webpack_public_path__ + "img/CircleLoad.63a2c7e0.svg";